import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu-unfold",
  "use": "icon-menu-unfold-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-menu-unfold\"><path d=\"M113 224h800c26.5 0 48-21.5 48-48s-21.5-48-48-48H113c-26.5 0-48 21.5-48 48s21.5 48 48 48z m800 240H433c-26.5 0-48 21.5-48 48s21.5 48 48 48h480c26.5 0 48-21.5 48-48s-21.5-48-48-48zM243.7 355.6L78.6 499.9c-6.7 5.8-7.3 15.9-1.5 22.6 0.5 0.5 1 1.1 1.5 1.5l165.1 144c3.3 2.9 8.4 2.6 11.3-0.8 1.3-1.5 2-3.3 2-5.3V361.6c0-4.4-3.6-8-8-8-1.9 0-3.8 0.7-5.3 2zM913 800H113c-26.5 0-48 21.5-48 48s21.5 48 48 48h800c26.5 0 48-21.5 48-48s-21.5-48-48-48z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu-unfold.svg
// module id = PZPB
// module chunks = 95